<app-alert></app-alert>
<section class="card">

  <div class="card-header">
    <title>Register of Postal Ballot</title>
    <span class="cat__core__title">
      <strong id="pageTitle">Register of Postal Ballot</strong>
    </span>

    <span style="float: right">
      <!-- <a routerLink="/postallballotlist"> -->
        <button (click)="back()"class="btn btn-sm btn-default pull-right btn-back" type="button">
          <i class=" fa fa-chevron-circle-left"></i>
          Back
        </button>
      <!-- </a> -->
    </span>
    <!-- <span style="float:right">
      <button class="btn btn-success pull-right" class="btn btn-sm btn-primary" style="margin-right: 8px;" (click)="generateOutput()" type="button" *ngIf="!addBtn">
        <span>
          <i class="fa fa-save"></i>Generate Output</span>
      </button>
</span> -->
    <meta charset="utf-8">
  </div>

  

      <form [formGroup]='pbForm' (document:click)="a.close();b.close()">
          <div class="modal-body">
        <div class="row">
          <div class="form-group col-md-4 col-sm-6 col-xs-12">
            <label>Sr. No. given by the scrutinizer</label>
            <input type="text" class="form-control" [formControl]="pbForm.controls['srNoGivenByTheScrutinizer']">
            <div class="form-control-error-custom"
              *ngIf="pbForm.controls['srNoGivenByTheScrutinizer'].hasError('pattern')">
              Sr. No. given by the scrutinizer is invalid
            </div>
          </div>
          <!-- <div class="form-group col-md-4 col-sm-6 col-xs-12">
            <label>Date of Receipt of postal ballot form</label>
            <div class="input-group">
              <input class="form-control" [formControl]="pbForm.controls['dateOfReceiptpb']" [(ngModel)]="dateofreceipt"
                style="padding:6px;z-index: 0;" placeholder="dd-mm-yyyy" ngbDatepicker #a="ngbDatepicker"
                (click)="a.toggle()">
              <button class="input-group-addon" (click)="a.toggle()" type="button">
                <span class="fa fa-calendar" style="width: 1rem; height: 0.7rem; cursor: pointer;"></span>
              </button>
            </div>
          </div> -->
          <div class="form-group col-md-4 col-sm-6 col-xs-12">
            <label>Date of receipt of postal ballot form</label>
            <div class="input-group" (click)="$event.stopPropagation()">
              <input class="form-control" [formControl]="pbForm.controls['dateOfReceiptpb']"
                [(ngModel)]="dateofreceipt" style="padding:6px;z-index: 0;" placeholder="dd-mm-yyyy" name="titledate"
                ngbDatepicker #a="ngbDatepicker" (click)="a.toggle()">
              <button class="input-group-addon" (click)="a.toggle()" type="button">
                <span class="fa fa-calendar"style="width: 1rem; height: 0.7rem; cursor: pointer;"></span>
              </button>
            </div>
  
          </div>

          <div class="form-group col-md-4 col-sm-6 col-xs-12">
            <label>Name of the Shareholder</label>
            <span _ngcontent-c2="" style="color: red;">*</span>
            <input type="text" class="form-control" [formControl]="pbForm.controls['nameOfShareholder']"
              required="required">
            <div class="form-control-error-custom"
              *ngIf="pbForm.controls['nameOfShareholder'].hasError('required') && pbForm.controls['nameOfShareholder'].touched">
              Name of the Shareholder is required
            </div>
            <div class="form-control-error-custom" *ngIf="pbForm.controls['nameOfShareholder'].hasError('pattern')">
              Name of the Shareholder is invalid
            </div>
          </div>

        </div>

        <div class="row">
          <div class="form-group col-md-4 col-sm-6 col-xs-12">
            <label>Address of the Shareholder</label>
            <input type="text" class="form-control" [formControl]="pbForm.controls.addressOfSH">
            <div class="form-control-error-custom" *ngIf="pbForm.controls['addressOfSH'].hasError('pattern')">
              Address of the Shareholder is invalid
            </div>
          </div>
          <div class="form-group col-md-4 col-sm-6 col-xs-12">
            <label>Folio No. of the Shareholder</label>
            <span _ngcontent-c1="" style="color: red;">*</span>
            <input type="text" class="form-control" [formControl]="pbForm.controls.folioNo">
            <div *ngIf="pbForm.controls['folioNo'].hasError('required') && pbForm.controls['folioNo'].touched"
              class="form-control-error-custom">
              Folio No. of the Shareholder is required
            </div>
            <div class="form-control-error-custom" *ngIf="pbForm.controls['folioNo'].hasError('pattern')">
              Folio No. of the Shareholder is invalid
            </div>
          </div>
          <div class="form-group col-md-4 col-sm-6 col-xs-12">
            <label>Client ID number of the Shareholder</label>
            <input type="text" class="form-control" (keydown)="onlyNumber($event)"
              [formControl]="pbForm.controls.clientIdNumberSH">
            <div class="form-control-error-custom" *ngIf="pbForm.controls['clientIdNumberSH'].hasError('pattern')">
              Client ID number of the Shareholder is invalid
            </div>
          </div>
        </div>

        <div class="row">
          <div class="form-group col-md-4 col-sm-6 col-xs-12"><br>
            <label>Number of shares held by Shareholder</label>
            <input type="text" class="form-control" (keydown)="onlyNumber($event)"
              [formControl]="pbForm.controls.numberOfSharesSH">
            <div class="form-control-error-custom" *ngIf="pbForm.controls['numberOfSharesSH'].hasError('pattern')">
              Number of shares held by Shareholder is invalid
            </div>
          </div>
          <div class="form-group col-md-4 col-sm-6 col-xs-12"><br>
            <label>Nominal value of shares</label>
            <input type="text" class="form-control" [formControl]="pbForm.controls.nominalValueSH">
            <div class="form-control-error-custom" *ngIf="pbForm.controls['nominalValueSH'].hasError('pattern')">
              Nominal value of shares is invalid
            </div>
          </div>
          <div class="form-group col-md-4 col-sm-6 col-xs-12">
            <label>Details of postal ballots which are received in defaced form</label>
            <input type="text" class="form-control" [formControl]="pbForm.controls.detailsOfPostalBallots">
            <div class="form-control-error-custom"
              *ngIf="pbForm.controls['detailsOfPostalBallots'].hasError('pattern')">
              Details of postal ballots is invalid
            </div>
          </div>
        </div>

        <div class="row">
          <div class="form-group col-md-4 col-sm-6 col-xs-12">
            <label>Details of postal ballots which are received in mutilated form</label>
            <input type="text" class="form-control" [formControl]="pbForm.controls.detailPostalBallotReceived">
            <div class="form-control-error-custom"
              *ngIf="pbForm.controls['detailPostalBallotReceived'].hasError('pattern')">
              Details of postal ballots is invalid
            </div>
          </div>
          <div class="form-group col-md-4 col-sm-6 col-xs-12"><br>
            <label>Whether the shares have differential voting rights</label>
            <input type="text" class="form-control" [formControl]="pbForm.controls.differentialVotingRights">
            <div class="form-control-error-custom"
              *ngIf="pbForm.controls['differentialVotingRights'].hasError('pattern')">
              Whether the shares have differential voting rights is invalid
            </div>
          </div>
          <div class="form-group col-md-4 col-sm-6 col-xs-12"><br>
            <label>Determination of Postal ballot forms, which are invalid</label>
            <input type="text" class="form-control" [formControl]="pbForm.controls.determinationpostalballot">
            <div class="form-control-error-custom"
              *ngIf="pbForm.controls['determinationpostalballot'].hasError('pattern')">
              Determination of Postal ballot forms is invalid
            </div>
          </div>
        </div>

        <div class="row">
          <div class="form-group col-md-4 col-sm-6 col-xs-12">
            <label>No. of votes in favour</label>
            <input type="text" class="form-control" (keydown)="onlyNumber($event)"
              [formControl]="pbForm.controls.votesInFavour">
            <div class="form-control-error-custom" *ngIf="pbForm.controls['votesInFavour'].hasError('pattern')">
              No. of votes in favour is invalid
            </div>
          </div>
          <div class="form-group col-md-4 col-sm-6 col-xs-12">
            <label>No. of votes in against</label>
            <input type="text" class="form-control" (keydown)="onlyNumber($event)"
              [formControl]="pbForm.controls.votesAgainst">
            <div class="form-control-error-custom" *ngIf="pbForm.controls['votesAgainst'].hasError('pattern')">
              No. of votes in against is invalid
            </div>
          </div>
          <div class="form-group col-md-4 col-sm-6 col-xs-12">
            <label>No. of invalid votes and reasons thereof</label>
            <input type="text" class="form-control"
              [formControl]="pbForm.controls.invalidVotes">
            <div class="form-control-error-custom" *ngIf="pbForm.controls['invalidVotes'].hasError('pattern')">
              No. of invalid votes and reasons thereof is invalid
            </div>
          </div>
        </div>

        <div class="row">
          <!-- <div class="form-group col-md-4 col-sm-6 col-xs-12">
            <label class="form-group">Date of Passing Resolution</label>
            <div class="input-group">
              <input class="form-control" [formControl]="pbForm.controls['dateOfPassingResolutionPB']"
                [(ngModel)]="dateofpassingresolution" style="padding:6px;z-index: 0;" placeholder="dd-mm-yyyy"
                ngbDatepicker #b="ngbDatepicker" (click)="b.toggle()">
              <button class="input-group-addon" (click)="b.toggle()" type="button">
                <span class="fa fa-calendar" style="width: 1rem; height: 0.7rem; cursor: pointer;"></span>
              </button>
            </div>
          </div> -->
          <div class="form-group col-md-4 col-sm-6 col-xs-12">
            <label>Date of Passing Resolution</label>
            <div class="input-group" (click)="$event.stopPropagation()">
              <input class="form-control" [formControl]="pbForm.controls['dateOfPassingResolutionPB']"
                [(ngModel)]="dateofpassingresolution" style="padding:6px;z-index: 0;" placeholder="dd-mm-yyyy" name="titledate"
                ngbDatepicker #b="ngbDatepicker" (click)="b.toggle()">
              <button class="input-group-addon" (click)="b.toggle()" type="button">
                <span class="fa fa-calendar"style="width: 1rem; height: 0.7rem; cursor: pointer;"></span>
              </button>
            </div>
  
          </div>
          <div class="form-group col-md-4 col-sm-6 col-xs-12">
            <label>Resolution Number</label>
            <input type="text" class="form-control" (keydown)="onlyNumber($event)"
              [formControl]="pbForm.controls.resolutionNumber">
            <div class="form-control-error-custom" *ngIf="pbForm.controls['resolutionNumber'].hasError('pattern')">
              Resolution Number is invalid
            </div>
          </div>
          <div class="form-group col-md-4 col-sm-6 col-xs-12">
            <label>Resolution Name</label>
            <input type="text" class="form-control" [formControl]="pbForm.controls.resolutionName">
            <div class="form-control-error-custom" *ngIf="pbForm.controls['resolutionName'].hasError('pattern')">
              Resolution Name is invalid
            </div>
          </div>
        </div>

        <div class="row">
          <div class="form-group col-md-4 col-sm-6 col-xs-12">
            <label>Name of scrutinizer</label>
            <input type="text" class="form-control" [formControl]="pbForm.controls.nameOfScrutizer">
            <div class="form-control-error-custom" *ngIf="pbForm.controls['nameOfScrutizer'].hasError('pattern')">
              Name of scrutinizer is invalid
            </div>
          </div>
          <div class="form-group col-md-4 col-sm-6 col-xs-12">
            <label>Address of scrutinizer</label>
            <input type="text" class="form-control" [formControl]="pbForm.controls.addressOfScrutizer">
            <div class="form-control-error-custom" *ngIf="pbForm.controls['addressOfScrutizer'].hasError('pattern')">
              Address of scrutinizer is invalid
            </div>
          </div>
          <div class="form-group col-md-4 col-sm-6 col-xs-12">
            <label>Remarks, if any</label>
            <textarea class="form-control" [formControl]="pbForm.controls.remarks"></textarea>
          </div>
        </div>
      </div>

        <div class="card-footer" align="right">
          <button class="btn btn-sm btn-primary" (click)="savePostalballot()" type="button" [disabled]="!pbForm.valid || disabledOnClick" *ngIf="addBtn">
            <i class="fa fa-save"></i>&nbsp;Save</button>
          <button class="btn btn-sm btn-primary" (click)="updatePostalballot(editPostalBallotId._id)" type="button"
            [disabled]="!pbForm.valid || disabledOnClick" *ngIf="!addBtn">
            <i class="fa fa-save"></i>&nbsp;Update</button>
        </div>
      </form>
   
</section>